import axios from 'axios';
import { login, register, validateToken, userProfile, userUpdate, userLoanHistory, validateMobile, validateCode, userLoanEligibility, sendValidationCode, resetPassword, profilePhoto, sendEmailOtpUrl, verifyEmailOtpUrl } from './endpointUrl';
import { headers } from './auth-header';

export const userLogin = async (loginCred: any) => {
  const response = await axios.post(login, loginCred);
  return response.data;
};

export const userRegister = async (registerData: any) => {
  const response = await axios.post(register, registerData);
  return response.data;
};

export const sendEmailValidatationCode = async (data: any) => {
  const response = await axios.post(sendValidationCode, data);
  return response.data;
};

export const userEmailValidate = async (data: any) => {
  const response = await axios.post(validateCode, data);
  return response.data;
};

export const userResetPassword = async (data: any) => {
  const response = await axios.post(resetPassword, data);
  return response.data;
};

export const userMobileValidate = async (data: any) => {
  const response = await axios.post(validateMobile, data);
  return response.data;
};

export const validateUserToken = async () => {
  const response = await axios.get(validateToken,{ headers: headers });
  return response.data;
};

export const getProfile = async () => {
  const response = await axios.get(userProfile,{ headers: headers });
  return response.data;
};

export const updateMyProfile = async (profileData: any) => {
  const response = await axios.post(userUpdate, profileData, { headers: headers });
  return response.data;
};

export const getUserLoanHistory = async () => {
  const response = await axios.get(userLoanHistory,{ headers: headers });
  return response.data;
};

export const getUserLoanEligibility = async (data: any) => {
  const response = await axios.get(userLoanEligibility+data,{ headers: headers });
  return response.data;
};

export const sendEmailOtp = async (data: any) => {
  const response = await axios.get(sendEmailOtpUrl+data,{ headers: headers });
  return response.data;
};

export const verifyEmailOtp = async (data: any) => {
  const response = await axios.get(verifyEmailOtpUrl+data,{ headers: headers });
  return response.data;
};

export const changeProfilePhoto = async (photo: any) => {
  const response = await axios.post(profilePhoto, photo, { headers: {Authorization: `Bearer ${localStorage.getItem("access_token")}` }});
  return response.data;
};